import { PaletteColor, useTheme } from "@mui/material";
import { useMemo } from "react";
import { useFetchProductsByReleaseIdPublicQuery } from "../../../api/products/hooks/usefetchProductsByReleaseIdPublicQuery";
import { isScheduledSimple } from "../../../utils/releases/dateUtils";
import { FeatureReleasePill } from "./FeaturedReleasePill";

interface FeaturedReleasePillProps {
  releaseId: number | undefined;
  text?: string;
  color?: PaletteColor;
}

export const FeaturedProductReleasePill = ({
  text = "Featured release",
  releaseId,
}: FeaturedReleasePillProps) => {
  const { data: products } = useFetchProductsByReleaseIdPublicQuery(releaseId);
  const firstProduct = products?.[0];

  const theme = useTheme();
  const isScheduled = useMemo(() => {
    if (!firstProduct) return false;
    return isScheduledSimple(
      firstProduct.published_at || null,
      firstProduct.published_end || null,
    );
  }, [firstProduct]);
  const featuredPillText = useMemo(() => {
    return isScheduled ? "Upcoming release" : text;
  }, [isScheduled, text]);
  const productStatusColor = useMemo(() => {
    return isScheduled ? theme.palette.pending : theme.palette.active;
  }, [isScheduled, theme.palette.active, theme.palette.pending]);

  return (
    <FeatureReleasePill text={featuredPillText} color={productStatusColor} />
  );
};
